import { types } from "mobx-state-tree";

export const StorageUserModel = types
  .model({
    jwt: types.maybeNull(types.string),
  })
  .actions((self) => ({
    deleteToken: (): void => {
      self.jwt = null;
    },
    setToken: (jwt: string): void => {
      self.jwt = jwt;
    },
  }))
  .views((self) => ({
    get getToken(): string | null {
      return self.jwt;
    },
  }));
